import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const ConflictOrderModal = ({
  visible,
  onCancel,
  onOk,
  conflicts = [],
  conflictKey,
}) => {
  const [items, setItems] = useState([]);

  const setConflicts = useCallback(() => {
    if (Array.isArray(conflicts)) {
      const sanitized = conflicts.map((item) => ({
        ...item,
        uid: uuidv4(),
      }));
      setItems(sanitized);
    }
  }, [conflicts]);

  useEffect(() => {
    setConflicts();
  }, [conflicts, conflictKey, setConflicts]);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reordered = Array.from(items);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setItems(reordered);
  };

  const handleOk = () => {
    onOk(conflictKey, items);
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      title="Plusieurs périodes se chevauchent sur le même intervalle"
    >
      <p>
        Afin d’assurer le bon déroulement du planning, vous devez définir un
        ordre d’affichage en classant ces périodes par ordre chronologique.
        Faites glisser chaque élément pour organiser leur succession.
      </p>

      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="conflict-order">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                minHeight: 120,
                padding: 8,
                background: "#fafafa",
                border: "1px dashed #ccc",
                borderRadius: 4,
              }}
            >
              {items.map((item, index) => (
                <Draggable key={item.uid} draggableId={item.uid} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        userSelect: "none",
                        padding: 10,
                        marginBottom: 8,
                        backgroundColor: snapshot.isDragging
                          ? "#e6f7ff"
                          : "#ffffff",
                        border: "1px solid #1890ff",
                        borderRadius: 4,
                        fontWeight: 500,
                        boxShadow: snapshot.isDragging
                          ? "0 2px 6px rgba(0,0,0,0.2)"
                          : "none",
                        transition: "background-color 0.2s ease",
                        ...provided.draggableProps.style,
                      }}
                    >
                      {`${item.colName || "Période inconnue"}${
                        item.itemIdx !== undefined
                          ? ` N° ${item.itemIdx + 1}`
                          : ""
                      }`}
                    </div>
                  )}
                </Draggable>
              ))}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default ConflictOrderModal;
